import { Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { TASelect } from '../../ta-select';

export const JobRejectionModalForm: React.FC<any> = ({ onCancel, onOk, showOther, headerTitle, visible, options }) => {
	const [showOtherInput, setShowOtherInput] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);

	const [form] = Form.useForm();

	const onFormCancel = () => {
		form.resetFields();

		onCancel && onCancel();
	};
	const onFinish = async values => {
		setLoading(true);
		onOk && onOk(values.other || values.reason);
		setLoading(false);
		form.resetFields();
	};
	const onReasonChange = v => {
		setShowOtherInput(v === 'Other');
		form.setFieldsValue({ reason: v });
	};

	return (
		<Modal
			title={headerTitle || 'Rejection form'}
			visible={visible}
			onCancel={onFormCancel}
			onOk={form.submit}
			okText="Reject"
			okButtonProps={{ loading }}
			className="ta-modal"
		>
			<Form
				layout="horizontal"
				className="ta-form py-5"
				labelCol={{ xs: { span: 12 }, xl: { span: 8 } }}
				wrapperCol={{ xs: { span: 12 }, xl: { span: 16 } }}
				labelAlign="left"
				form={form}
				onFinish={onFinish}
			>
				<Form.Item label="Rejection Reason" name="reason">
					<TASelect
						placeholder="Please, Select the rejection reason"
						onChange={onReasonChange}
						showSearch
						filterOption={(input, option) =>
							option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
					>
						{options.map(o => (
							<TASelect.Option value={o} key={o}>
								{o}
							</TASelect.Option>
						))}
						{showOther && (
							<TASelect.Option value="Other" key="Other">
								Other
							</TASelect.Option>
						)}
					</TASelect>
				</Form.Item>

				{showOther && showOtherInput && (
					<Form.Item label="Rejection feedback" name="other">
						<Input placeholder="Please, Select the rejection reason" />
					</Form.Item>
				)}
			</Form>
		</Modal>
	);
};
